var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_603_539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.970215,
    y: 0.0224609,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_603_539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_2",
    d: "M6.80339 22.1895H8.08439L20.5657 9.70845L19.2844 8.42716L6.80339 20.9085V22.1895ZM5.63672 23.3561V20.417L21.0143 5.0237C21.1338 4.91715 21.2658 4.8348 21.4101 4.77666C21.5545 4.71852 21.7051 4.68945 21.8618 4.68945C22.0186 4.68945 22.1704 4.71415 22.3174 4.76354C22.4642 4.81292 22.5998 4.90188 22.724 5.03041L23.9691 6.28254C24.0977 6.40659 24.1856 6.5427 24.2328 6.69087C24.2799 6.83923 24.3034 6.98749 24.3034 7.13566C24.3034 7.29374 24.2767 7.44502 24.2235 7.58949C24.1702 7.73377 24.0854 7.8657 23.9691 7.98529L8.57584 23.3561H5.63672ZM19.9138 9.07904L19.2844 8.42716L20.5657 9.70845L19.9138 9.07904Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/EditButton.0484d19fdb7a8516e435b75c9981f47b.svg";
export { ForwardRef as ReactComponent };